import styled from 'styled-components';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    font-size: 16px;
`;

const StyledFooter = styled.div`
    padding: 10px;
    button{
        background-color: var(--redColor1);
        border: none;
        color: #fff;
        font-weight: 600;
    }
`;

export function ModalDelete({
    open,
    onClose,
    onDelete
}) {
    const handleDelete = async () => {
        onDelete();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            삭제
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div>
                        정말로 삭제하시겠습니까?
                    </div>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={handleDelete}
                    >
                        삭제
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}